<template>
  <div id="app">
    <!-- <div class="nav-links"> -->
      <!-- <router-link to="/">首页</router-link> -->
      <!-- <router-link to="/image-editor"></router-link> -->
    <!-- </div> -->
    <router-view/>
  </div>
</template>

<script>
// -import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}

.nav-links {
  margin: 20px 0;
}

.nav-links a {
  margin: 0 10px;
  color: #2c3e50;
  text-decoration: none;
}

.nav-links a.router-link-exact-active {
  color: #42b983;
}
</style>
